module.exports = __webpack_public_path__ + "img/2010-3.6fdb9f36.jpg";